import { render, staticRenderFns } from "./Telesalud.vue?vue&type=template&id=7cd86de9&scoped=true"
import script from "./Telesalud.vue?vue&type=script&lang=ts"
export * from "./Telesalud.vue?vue&type=script&lang=ts"
import style0 from "./Telesalud.vue?vue&type=style&index=0&id=7cd86de9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd86de9",
  null
  
)

export default component.exports